export default "__VITE_ASSET__Dzckppqo__"